const switchButtons = document.querySelectorAll('.mm-switch:not(.custom-switch) .mm-switch__toggle');

const toggleActiveButton = (btn) => {
  switchButtons.forEach(b => b.classList.remove('-active'));
  btn.target.closest('.mm-switch__toggle').classList.add('-active');
} 

switchButtons ? switchButtons.forEach(b => b.addEventListener('click', (e) => toggleActiveButton(e))) : null;
